import Vue from 'vue'
import App from './App.vue'
import router from './router'
// 使用Vuex全局变量
import Vuex from 'vuex';
// 引入全局消息Element组件
import NotificationPlugin from '../js/notificationPlugin';
// 引入Element组件
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
// 按需引入引入Element组件
import './components/element/index'

// 引入echarts
import echarts from '../js/echarts'

// 使用Element组件
// Vue.use(ElementUI);
// 引入vuex组件
Vue.use(Vuex);
// 使用全局消息组件
Vue.use(NotificationPlugin);
//vue全局注入echarts

Vue.prototype.$echarts = echarts


Vue.config.productionTip = false
const store = new Vuex.Store({
  state: {
    userLoginClient: '',
    routerTopShow: true,
    routerFooterShow: true,
    routerTopBack: 1,
    username: '',
    loginStatus: false,
  }
});

// 跳转后返回顶部
router.afterEach(() => {
  window.scrollTo(0,0);
})


new Vue({
  router,
  render: h => h(App),
  store: store  // 注入 Vuex Store 到根 Vue 实例
}).$mount('#app')

// 初始化store
export default store;

Vue.config.silent = true; // 关闭所有警告
